import { ReactEditor } from 'slate-react';

function getDOMRange(editor, range) {
  try {
    return ReactEditor.toDOMRange(editor, range);
  } catch (error) {
    return getDOMRange(editor, {
      anchor: range.anchor,
      focus: range.anchor
    });
  }
}

export { getDOMRange };
//# sourceMappingURL=get-dom-range.js.map
